// @ts-nocheck
// this file was patched by @terra

import { z } from 'zod';

export const PrEndpointImpactSourceBucketSchema = z.enum(['ENTRY_POINT','GATEKEEPER','LOGIC','DEPENDENCY'] as const);

export type PrEndpointImpactSourceBucketType = `${z.infer<typeof PrEndpointImpactSourceBucketSchema>}`

export default PrEndpointImpactSourceBucketSchema;
